// Much older content stores both languages in ONE string, e.g.
//   "1. स्नान एवं शुद्धि · Snana & Shuddhi"
//   "मिट्टी का कलश जल सहित — Clay kalash filled with clean water"
//   "<Hindi paragraph>\n<English paragraph>"
// so the language switch could not separate them and pages showed both.
// pickScript() shows only the half in the reader's script. Single-language
// strings, mixed lines and anything it can't split cleanly are returned as-is.
const DEVA = /[ऀ-ॿ]/;
const LATIN_WORD = /[A-Za-z]{2,}/;
const DEVA_LANGS = new Set(["hi", "sa", "mr"]);

const isDeva = (s) => DEVA.test(s) && !LATIN_WORD.test(s);
const isLatin = (s) => !DEVA.test(s) && LATIN_WORD.test(s);

function pickPair(a, b, wantDeva) {
  if (isDeva(a) && isLatin(b)) return wantDeva ? a : b;
  if (isLatin(a) && isDeva(b)) return wantDeva ? b : a;
  return null;
}

export function pickScript(text, lang) {
  if (typeof text !== "string" || !text || !DEVA.test(text) || !LATIN_WORD.test(text)) return text;
  const wantDeva = DEVA_LANGS.has(lang);

  // Paragraph pairs: keep the lines in the reader's script, if the lines split cleanly.
  if (text.includes("\n")) {
    const lines = text.split("\n");
    const body = lines.filter((l) => l.trim());
    if (body.length > 1 && body.every((l) => isDeva(l) || isLatin(l)) && body.some(isDeva) && body.some(isLatin)) {
      return lines.filter((l) => !l.trim() || (wantDeva ? isDeva(l) : isLatin(l))).join("\n").trim();
    }
    return text;
  }

  // Inline pairs: "<deva> · <latin>" or "<deva> — <latin>", keeping a leading "1. ".
  const m = text.match(/^(\s*\d+[.)]\s*)?(.*)$/s);
  const prefix = (m && m[1]) || "";
  const rest = m ? m[2] : text;
  for (const sep of [" · ", " — ", " – "]) {
    const parts = rest.split(sep);
    if (parts.length === 2) {
      const chosen = pickPair(parts[0].trim(), parts[1].trim(), wantDeva);
      if (chosen) return prefix + chosen;
    }
  }
  return text;
}
